import React, {useState} from "react";
import ListMessages from "./ListMessages";
import CreateSeriesOfPostsFromArrayMessageModal from "../modals/CreateSeriesOfPostsFromArrayMessageModal";
import {useNavigate} from "react-router-dom";
import {fetchWrapper} from "../../helpers";
import {message, message as Message} from "antd";
import {useTranslation} from "react-i18next";
import {CopyOutlined} from "@ant-design/icons";


const MessagesArray = ({msData, messages, snActions}) => {
	const navigate = useNavigate();
	const {t} = useTranslation();
	const [selectedPosts, setSelectedPosts] = useState(messages.filter(item => item.type === 'post'));
	const [isLoading, setIsLoading] = useState(false);

	const copyMessagesToClipboard = () => {
		const keys = ['title', 'content', 'hashtags', 'media'];
		let buffer = '';
		messages.forEach((item)=>{
			keys.forEach((key)=>{
				if (item[key]){
					buffer += `${item[key]}\n`;
				}
			});
			buffer += '\n\n\n';
		});
		buffer = buffer.split('\n\n\n').filter((item)=> item !== '\n').join('\n\n\n');
		buffer += `\n\n\n${t('functions.copiedFromService')} IMEAN:\nhttps://my.imean.io/`;
		navigator.clipboard.writeText(buffer);
		message.success(t("functions.copied"));
		// console.log(buffer);
	};

	// const createPostFromMessage = (postText) => {
	// 	setIsLoading(true)
	// 	const newPostDescription = `${postText.trim()}`;
	// 	const date = new Date();
	// 	fetchWrapper
	// 			.post(`${process.env.REACT_APP_API_URL}/assistant/summary`, {
	// 				content: newPostDescription,
	// 				socialNetwork: snActions?.socialNetworks,
	// 				date: date.toISOString(),
	// 			})
	// 			.then((res) => {
	// 				if (res){
	// 					Message.loading(t("functions.generating"));
	// 					navigate(`/create-post/${res.contentPlanId}`);
	// 					// window?.location?.reload();
	// 				}else {
	// 					throw new Error('error');
	// 				}
	// 			})
	// 			.catch((err) => {
	// 				console.error(err);
	// 				Message.error(t("functions.wrong"));
	// 			})
	// 			.finally(()=>{
	// 				setIsLoading(false);
	// 			});
	// };
	return (
			<div className='flex items-start'>
				<div className='max-w-[90%]'>
					{messages.map((msg, index) => (
						<ListMessages
								id={index+1}
								key={msg?.id ?? index}
								msg={msg}
								msData={msData}
								selectedItems={selectedPosts}
								setSelectedItems={setSelectedPosts}
								messagesList={messages}
						/>
					))}
					<div
							className={
								`relative w-fit w-max max-w-[90%] py-2 px-4 rounded-lg mt-1 mb-2.5 shadow-lg border 
											${msData?.role === "assistant" ? "bg-white text-primary fade-in-from-left" : "bg-primary text-white ml-auto fade-in-from-right"}`
							}
					>
						<small className={`flex items-center gap-1 py-1 opacity-40 ${msData.role !== "assistant" && 'text-right'}`}>
							{new Date(msData?.date).toLocaleString()}
						</small>
					</div>
				</div>
					<div className='sticky top-0 mr-auto ml-2 flex flex-col justify-center items-center gap-2'>
						{Boolean(messages.find((item) => item?.type === 'post')) && (
							<CreateSeriesOfPostsFromArrayMessageModal
									postMessages={selectedPosts}
									snAction={snActions?.setSocialNetworks}
									socialNetworks={snActions?.socialNetworks}
									disabledButton={isLoading}
							/>
						)}
						<button
							onClick={copyMessagesToClipboard}
							className='shadow-md flex items-center justify-center bg-white text-primary hover:bg-violet-500 hover:text-white hover:shadow-lg aspect-square p-1 rounded-full text-md border w-10 h-10 duration-500'
						>
							<CopyOutlined  />
						</button>
					</div>
			</div>
	);
};

export default MessagesArray;